import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AdminMenuItem } from './../admin-menu/menu-items.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-menu-big',
  templateUrl: 'admin-menu-big.template.html',
})
export class AdminMenuBigComponent {
  @Input() menuItems: AdminMenuItem[];
  @Input() routePrefix: string = '/admin/';

  constructor(private router: Router, private translate: TranslateService) {}
}
